// extracted by mini-css-extract-plugin
module.exports = {"content":"infoList_content__vGS96","btn":"infoList_btn__4gMAa","icon":"infoList_icon__2R3Y7","text":"infoList_text__hx_cC"};